module.exports = require('./helpers/bundle-url').getBundleURL('dj12v') + "coinbase.c169dc7d.svg";